export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "site-header",
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkSpeakers: "nav-link-speakers",
  linkAgenda: "nav-link-agenda",
  linkPartners: "nav-link-partners",
  linkSponsors: "nav-link-sponsors",
  linkContact: "nav-link-contact",
  ctaEnquire: "nav-cta-enquire",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  cta: "hero-cta-enquire",
  ctaAgenda: "hero-cta-agenda",
};

export const CONTACT = {
  section: "contact-section",
  form: "enquiry-form",
  name: "enquiry-name",
  company: "enquiry-company",
  jobTitle: "enquiry-job-title",
  email: "enquiry-email",
  phone: "enquiry-phone",
  message: "enquiry-message",
  type: "enquiry-type",
  captcha: "enquiry-captcha-answer",
  captchaRefresh: "enquiry-captcha-refresh",
  submit: "enquiry-submit",
};
